import { ButtonV2, DataGridRef, Modal } from '@cimplico/components';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { useRef, useState } from 'react';
import { toastNotification } from '../../../../../../components/toast/Toast';
import { useCreateFYIDocuments } from '../../../../../../queries/use-create-fyi-documents';
import queryClient from '../../../../../../query-client';
import { Cabinet, FYIDocument } from '../../../../../../types/fyi-docs';
import FYICabinetDocumentsTable from './FYICabinetDocumentsTable';
import FYICabinetsTable from './FYICabinetsTable';

type FYIDocumentViewerProps = {
    onClose: () => void;
    entityName: string;
    entityId: string;
    fyiEntityId: number;
};

function FYIDocumentViewer({ entityId, onClose, fyiEntityId }: FYIDocumentViewerProps): JSX.Element {
    const createFYIDocumentsQuery = useCreateFYIDocuments();
    const tableRef = useRef<DataGridRef>(null);
    const [cabinet, setCabinet] = useState<Cabinet>();
    const [documents, setDocuments] = useState<FYIDocument[]>([]);

    function handleSubmit(): void {
        if (documents.length === 0) {
            return;
        }
        createFYIDocumentsQuery.mutate(
            { entityId, fyiDocuments: documents },
            {
                onSuccess: () => {
                    toastNotification('success', `Successfully added ${documents.length} documents!`);
                    // onClose();
                    queryClient.invalidateQueries(['fyi', 'documents']);
                    tableRef.current?.clear();
                },
                onError: () => {
                    toastNotification('error', `Unable to add documents!`);
                },
            }
        );
    }

    return (
        <Modal isOpen onClose={(): void => undefined}>
            <div className="w-screen max-w-[1024px] h-full min-h-[400px] max-h-[85vh] p-4 relative flex flex-col">
                <div className="mb-4">
                    <h2 className="text-gray-800 text-lg font-medium text-left">Select FYI Documents</h2>
                    <button className="absolute top-5 right-5" onClick={onClose}>
                        <XMarkIcon className="text-gray-600 h-5 w-5" />
                    </button>
                </div>

                <div className="h-full flex flex-col gap-2 justify-between grow overflow-auto">
                    <div className="overflow-auto flex flex-col flex-1 h-full">
                        {!cabinet && <FYICabinetsTable onSelect={setCabinet} />}

                        {cabinet && (
                            <FYICabinetDocumentsTable
                                cabinet={cabinet}
                                fyiEntityId={fyiEntityId}
                                onClose={(): void => setCabinet(undefined)}
                                onSelect={setDocuments}
                                tableRef={tableRef}
                            />
                        )}
                    </div>
                    <div className="flex justify-end gap-2">
                        <ButtonV2 type="hollow" label="Cancel" size="sm" onClick={(): void => onClose()} />
                        <ButtonV2
                            type="primary"
                            label={createFYIDocumentsQuery.isLoading ? 'Saving...' : `Save`}
                            size="sm"
                            onClick={handleSubmit}
                            isLoading={createFYIDocumentsQuery.isLoading}
                            isDisabled={createFYIDocumentsQuery.isLoading || documents.length > 100}
                            disabledHint={documents.length > 100 ? 'File limit exceeded. Please deselect some files to save.' : ''}
                        />
                    </div>
                </div>
            </div>
        </Modal>
    );
}
export default FYIDocumentViewer;
